import { useEffect } from 'react';

const useWhatsAppUTMLinkUpdater = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const utm_campaign = decodeURIComponent(urlParams.get("utm_campaign")?.trim() || "");
    const utm_source = decodeURIComponent(urlParams.get("utm_source")?.trim() || "");

    let newUrl;

    switch (utm_campaign) {
      case "Tirun_Discovery_Prospecting_Website_June23":
        newUrl = "https://wa.me/911149061000?text=Hello%2C%20I%20have%20a%20question%20about%20one%20of%20your%20cruises";
        break;
      case "CC_Generic_Phrase_May'23":
        newUrl = "https://wa.me/911149061000?text=Hello%20I%20have%20a%20question%20about%20Celebrity%20Cruise";
        break;
      case "RCI-Search-Generic-Exact-May23":
        newUrl = "https://wa.me/911149061000?text=Hello%20I%20have%20a%20question%20about%20Royal%20Caribbean%20International";
        break;
      case "RCI_HighIntent_G L_Phrase_LD":
      case "RCI_HighIntent_G+L_Phrase_LD":
        newUrl = "https://wa.me/911149061000?text=Hello%2C%20I%20have%20a%20question%20about%20RCI";
        break;
      case "RCI_SIN_TTM_Core_Generic_Exact_LD":
        newUrl = "https://wa.me/911149061000?text=Hello%2C%20I%20have%20a%20question%20about%20RCI%20for%20Singapore";
        break;
      case "RCI_ICON":
        newUrl = "https://wa.me/911149061000?text=Hello%2C%20I%20have%20a%20question%20about%20RCI%20Icon%20of%20the%20seas";
        break;
      case "DatabaseReactivation":
        newUrl = "https://wa.me/911149061000?text=Hello%20TIRUN%2C%20Let's%20Cruise%20Again";
        break;
      case "rci_demand_gen_custom_mar'24":
        newUrl = "https://wa.me/911149061000?text=Hello%20I%20have%20a%20question%20about%20Royal%20Caribbean%20Cruise";
        break;
      case "subscription_campaign":
        newUrl = "https://wa.me/911149061000?text=Hello%20TIRUN%2C%20I%20want%20to%20know%20about%20Cruise";
        break;
      case "CC-Generic-Phrase_Exact-May23":
        newUrl = "https://wa.me/911149061000?text=Hello%2C%20I%20have%20a%20question%20about%20Celebrity%20Cruises";
        break;
        case "RCI_Leads_Pmax_16April25":
        newUrl = "https://api.whatsapp.com/send?phone=911149061000&text=Hi%20I%20want%20to%20know%20more";
        break;
      default:
        newUrl = "https://wa.me/911149061000?text=Hello%2C%20I'm%20Interested%20in%20taking%20a%20cruise%20vacation";
    }

    if (utm_source === "Print") {
      newUrl = "https://wa.me/911149061000?text=Hi%20TIRUN%2C%20saw%20your%20ad%20today.%20Want%20to%20plan%20a%20cruise%20vacation!";
    }

    // Function to update existing button (e.g. third-party WhatsApp widget)
    function updateWhatsAppButton() {
      const waButton = document.querySelector(".wa-chat-box-content-send-btn");
      if (waButton) {
        waButton.setAttribute("href", newUrl);
        console.log("WhatsApp link updated successfully.");
      } else {
        console.log("WhatsApp button not found, retrying...");
        setTimeout(updateWhatsAppButton, 500);
      }
    }

    updateWhatsAppButton();
  }, []);
};

export default useWhatsAppUTMLinkUpdater;
